export enum Ds3Role {
  SIGNER = 'Signer',
  CARBON_COPY = 'CarbonCopy',
}

export enum Ds3SignerStatus {
  IN_PROGRESS = 'InProgress',
  COMPLETE = 'Complete',
}
